import BillingRunStatus from "@/modules/billingRunStatus/view/BillingRunStatus.vue";

export const BillingStateRoutes = [
    {
        path: '/billing/run/status',
        component: BillingRunStatus,
    }
]